/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { PdfSection } from './pdf-section';
import { NameValue } from '../../tool/name-value';
import { PdfUtils } from '../pdf-utils';
import { PdfHeader } from '../pdf-header';
import { TranslateService } from '@ngx-translate/core';

export class InfoPdfSection extends PdfSection {
  public info: NameValue[][];
  public columnCount: number;
  constructor(info: NameValue[][]) {
    super(null);
    this.info = info;
  }

  build(
    trl: TranslateService,
    doc,
    header: PdfHeader,
    x: number,
    y: number
  ): number {
    const maxHeight = doc.internal.pageSize.getHeight() - 30;
    doc.setDrawColor(47, 55, 58);
    doc.setTextColor(47, 55, 58);
    doc.setFontSize(10);
    const x2 = doc.internal.pageSize.getWidth() - 30 - x;
    let newY = y + this.margin.h;
    let newX = x + this.margin.w;
    const rowHeight = doc.getTextDimensions('To').h;
    for (const row of this.info) {
      const columnWidth = Math.ceil((x2 - 50) / row.length);
      for (const cell of row) {
        doc.setFont('roboto', 'bold');
        let labelSize = { w: 0, h: 0 };
        if (cell.name) {
          cell.name = trl.instant(cell.name);
          if (cell.value !== null && cell.value !== undefined) {
            labelSize = doc.getTextDimensions(cell.name + ': ');
            doc.text(newX, newY, cell.name + ': ');
            doc.setFont('roboto', 'normal');
            const text = PdfUtils.truncate(
              doc,
              cell.value,
              columnWidth - labelSize.w - 4
            );
            doc.setFont('roboto', 'normal');
            doc.text(
              newX + labelSize.w + 4 + cell.name.length * 0.3,
              newY,
              text
            );
          } else {
            doc.text(newX, newY, cell.name);
          }
        } else if (cell.value) {
          const text = PdfUtils.truncate(
            doc,
            cell.value,
            columnWidth - labelSize.w
          );
          doc.setFont('roboto', 'normal');
          doc.text(newX + labelSize.w, newY, text);
        }
        newX += columnWidth + this.margin.w;
      }
      newY += rowHeight + 5;
      newX = x + this.margin.w;
      if (newY + rowHeight + this.margin.h * 2 > maxHeight) {
        doc.rect(x, y, x2, newY - y - 5); // Rect logo
        PdfUtils.addPage(doc, header);
        y = header.height;
        newY = header.height + this.margin.h;
      }
    }
    doc.rect(x, y, x2, newY - y - 5); // Rect logo
    return newY - 10;
  }

  getDimension(doc: unknown): { w: number; h: number } {
    void doc;
    return { h: 0, w: 0 };
  }
}
